"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMEZONE_LABEL = exports.ALL_TIMEZONES = exports.TIMEZONES_MIGRATION_MAP = exports.DEPRECATED_TIMEZONE_KEYS = exports.TIMEZONE = exports.MOMENT_TIMEZONES = void 0;
var MOMENT_TIMEZONES;
(function (MOMENT_TIMEZONES) {
    MOMENT_TIMEZONES["Africa/Abidjan"] = "Africa/Abidjan";
    MOMENT_TIMEZONES["Africa/Accra"] = "Africa/Accra";
    MOMENT_TIMEZONES["Africa/Addis_Ababa"] = "Africa/Addis_Ababa";
    MOMENT_TIMEZONES["Africa/Algiers"] = "Africa/Algiers";
    MOMENT_TIMEZONES["Africa/Asmara"] = "Africa/Asmara";
    MOMENT_TIMEZONES["Africa/Asmera"] = "Africa/Asmera";
    MOMENT_TIMEZONES["Africa/Bamako"] = "Africa/Bamako";
    MOMENT_TIMEZONES["Africa/Bangui"] = "Africa/Bangui";
    MOMENT_TIMEZONES["Africa/Banjul"] = "Africa/Banjul";
    MOMENT_TIMEZONES["Africa/Bissau"] = "Africa/Bissau";
    MOMENT_TIMEZONES["Africa/Blantyre"] = "Africa/Blantyre";
    MOMENT_TIMEZONES["Africa/Brazzaville"] = "Africa/Brazzaville";
    MOMENT_TIMEZONES["Africa/Bujumbura"] = "Africa/Bujumbura";
    MOMENT_TIMEZONES["Africa/Cairo"] = "Africa/Cairo";
    MOMENT_TIMEZONES["Africa/Casablanca"] = "Africa/Casablanca";
    MOMENT_TIMEZONES["Africa/Ceuta"] = "Africa/Ceuta";
    MOMENT_TIMEZONES["Africa/Conakry"] = "Africa/Conakry";
    MOMENT_TIMEZONES["Africa/Dakar"] = "Africa/Dakar";
    MOMENT_TIMEZONES["Africa/Dar_es_Salaam"] = "Africa/Dar_es_Salaam";
    MOMENT_TIMEZONES["Africa/Djibouti"] = "Africa/Djibouti";
    MOMENT_TIMEZONES["Africa/Douala"] = "Africa/Douala";
    MOMENT_TIMEZONES["Africa/El_Aaiun"] = "Africa/El_Aaiun";
    MOMENT_TIMEZONES["Africa/Freetown"] = "Africa/Freetown";
    MOMENT_TIMEZONES["Africa/Gaborone"] = "Africa/Gaborone";
    MOMENT_TIMEZONES["Africa/Harare"] = "Africa/Harare";
    MOMENT_TIMEZONES["Africa/Johannesburg"] = "Africa/Johannesburg";
    MOMENT_TIMEZONES["Africa/Juba"] = "Africa/Juba";
    MOMENT_TIMEZONES["Africa/Kampala"] = "Africa/Kampala";
    MOMENT_TIMEZONES["Africa/Khartoum"] = "Africa/Khartoum";
    MOMENT_TIMEZONES["Africa/Kigali"] = "Africa/Kigali";
    MOMENT_TIMEZONES["Africa/Kinshasa"] = "Africa/Kinshasa";
    MOMENT_TIMEZONES["Africa/Lagos"] = "Africa/Lagos";
    MOMENT_TIMEZONES["Africa/Libreville"] = "Africa/Libreville";
    MOMENT_TIMEZONES["Africa/Lome"] = "Africa/Lome";
    MOMENT_TIMEZONES["Africa/Luanda"] = "Africa/Luanda";
    MOMENT_TIMEZONES["Africa/Lubumbashi"] = "Africa/Lubumbashi";
    MOMENT_TIMEZONES["Africa/Lusaka"] = "Africa/Lusaka";
    MOMENT_TIMEZONES["Africa/Malabo"] = "Africa/Malabo";
    MOMENT_TIMEZONES["Africa/Maputo"] = "Africa/Maputo";
    MOMENT_TIMEZONES["Africa/Maseru"] = "Africa/Maseru";
    MOMENT_TIMEZONES["Africa/Mbabane"] = "Africa/Mbabane";
    MOMENT_TIMEZONES["Africa/Mogadishu"] = "Africa/Mogadishu";
    MOMENT_TIMEZONES["Africa/Monrovia"] = "Africa/Monrovia";
    MOMENT_TIMEZONES["Africa/Nairobi"] = "Africa/Nairobi";
    MOMENT_TIMEZONES["Africa/Ndjamena"] = "Africa/Ndjamena";
    MOMENT_TIMEZONES["Africa/Niamey"] = "Africa/Niamey";
    MOMENT_TIMEZONES["Africa/Nouakchott"] = "Africa/Nouakchott";
    MOMENT_TIMEZONES["Africa/Ouagadougou"] = "Africa/Ouagadougou";
    MOMENT_TIMEZONES["Africa/Porto-Novo"] = "Africa/Porto-Novo";
    MOMENT_TIMEZONES["Africa/Sao_Tome"] = "Africa/Sao_Tome";
    MOMENT_TIMEZONES["Africa/Timbuktu"] = "Africa/Timbuktu";
    MOMENT_TIMEZONES["Africa/Tripoli"] = "Africa/Tripoli";
    MOMENT_TIMEZONES["Africa/Tunis"] = "Africa/Tunis";
    MOMENT_TIMEZONES["Africa/Windhoek"] = "Africa/Windhoek";
    MOMENT_TIMEZONES["America/Adak"] = "America/Adak";
    MOMENT_TIMEZONES["America/Anchorage"] = "America/Anchorage";
    MOMENT_TIMEZONES["America/Anguilla"] = "America/Anguilla";
    MOMENT_TIMEZONES["America/Antigua"] = "America/Antigua";
    MOMENT_TIMEZONES["America/Araguaina"] = "America/Araguaina";
    MOMENT_TIMEZONES["America/Argentina/Buenos_Aires"] = "America/Argentina/Buenos_Aires";
    MOMENT_TIMEZONES["America/Argentina/Catamarca"] = "America/Argentina/Catamarca";
    MOMENT_TIMEZONES["America/Argentina/ComodRivadavia"] = "America/Argentina/ComodRivadavia";
    MOMENT_TIMEZONES["America/Argentina/Cordoba"] = "America/Argentina/Cordoba";
    MOMENT_TIMEZONES["America/Argentina/Jujuy"] = "America/Argentina/Jujuy";
    MOMENT_TIMEZONES["America/Argentina/La_Rioja"] = "America/Argentina/La_Rioja";
    MOMENT_TIMEZONES["America/Argentina/Mendoza"] = "America/Argentina/Mendoza";
    MOMENT_TIMEZONES["America/Argentina/Rio_Gallegos"] = "America/Argentina/Rio_Gallegos";
    MOMENT_TIMEZONES["America/Argentina/Salta"] = "America/Argentina/Salta";
    MOMENT_TIMEZONES["America/Argentina/San_Juan"] = "America/Argentina/San_Juan";
    MOMENT_TIMEZONES["America/Argentina/San_Luis"] = "America/Argentina/San_Luis";
    MOMENT_TIMEZONES["America/Argentina/Tucuman"] = "America/Argentina/Tucuman";
    MOMENT_TIMEZONES["America/Argentina/Ushuaia"] = "America/Argentina/Ushuaia";
    MOMENT_TIMEZONES["America/Aruba"] = "America/Aruba";
    MOMENT_TIMEZONES["America/Asuncion"] = "America/Asuncion";
    MOMENT_TIMEZONES["America/Atikokan"] = "America/Atikokan";
    MOMENT_TIMEZONES["America/Atka"] = "America/Atka";
    MOMENT_TIMEZONES["America/Bahia"] = "America/Bahia";
    MOMENT_TIMEZONES["America/Bahia_Banderas"] = "America/Bahia_Banderas";
    MOMENT_TIMEZONES["America/Barbados"] = "America/Barbados";
    MOMENT_TIMEZONES["America/Belem"] = "America/Belem";
    MOMENT_TIMEZONES["America/Belize"] = "America/Belize";
    MOMENT_TIMEZONES["America/Blanc-Sablon"] = "America/Blanc-Sablon";
    MOMENT_TIMEZONES["America/Boa_Vista"] = "America/Boa_Vista";
    MOMENT_TIMEZONES["America/Bogota"] = "America/Bogota";
    MOMENT_TIMEZONES["America/Boise"] = "America/Boise";
    MOMENT_TIMEZONES["America/Buenos_Aires"] = "America/Buenos_Aires";
    MOMENT_TIMEZONES["America/Cambridge_Bay"] = "America/Cambridge_Bay";
    MOMENT_TIMEZONES["America/Campo_Grande"] = "America/Campo_Grande";
    MOMENT_TIMEZONES["America/Cancun"] = "America/Cancun";
    MOMENT_TIMEZONES["America/Caracas"] = "America/Caracas";
    MOMENT_TIMEZONES["America/Catamarca"] = "America/Catamarca";
    MOMENT_TIMEZONES["America/Cayenne"] = "America/Cayenne";
    MOMENT_TIMEZONES["America/Cayman"] = "America/Cayman";
    MOMENT_TIMEZONES["America/Chicago"] = "America/Chicago";
    MOMENT_TIMEZONES["America/Chihuahua"] = "America/Chihuahua";
    MOMENT_TIMEZONES["America/Coral_Harbour"] = "America/Coral_Harbour";
    MOMENT_TIMEZONES["America/Cordoba"] = "America/Cordoba";
    MOMENT_TIMEZONES["America/Costa_Rica"] = "America/Costa_Rica";
    MOMENT_TIMEZONES["America/Creston"] = "America/Creston";
    MOMENT_TIMEZONES["America/Cuiaba"] = "America/Cuiaba";
    MOMENT_TIMEZONES["America/Curacao"] = "America/Curacao";
    MOMENT_TIMEZONES["America/Danmarkshavn"] = "America/Danmarkshavn";
    MOMENT_TIMEZONES["America/Dawson"] = "America/Dawson";
    MOMENT_TIMEZONES["America/Dawson_Creek"] = "America/Dawson_Creek";
    MOMENT_TIMEZONES["America/Denver"] = "America/Denver";
    MOMENT_TIMEZONES["America/Detroit"] = "America/Detroit";
    MOMENT_TIMEZONES["America/Dominica"] = "America/Dominica";
    MOMENT_TIMEZONES["America/Edmonton"] = "America/Edmonton";
    MOMENT_TIMEZONES["America/Eirunepe"] = "America/Eirunepe";
    MOMENT_TIMEZONES["America/El_Salvador"] = "America/El_Salvador";
    MOMENT_TIMEZONES["America/Ensenada"] = "America/Ensenada";
    MOMENT_TIMEZONES["America/Fort_Nelson"] = "America/Fort_Nelson";
    MOMENT_TIMEZONES["America/Fort_Wayne"] = "America/Fort_Wayne";
    MOMENT_TIMEZONES["America/Fortaleza"] = "America/Fortaleza";
    MOMENT_TIMEZONES["America/Glace_Bay"] = "America/Glace_Bay";
    MOMENT_TIMEZONES["America/Godthab"] = "America/Godthab";
    MOMENT_TIMEZONES["America/Goose_Bay"] = "America/Goose_Bay";
    MOMENT_TIMEZONES["America/Grand_Turk"] = "America/Grand_Turk";
    MOMENT_TIMEZONES["America/Grenada"] = "America/Grenada";
    MOMENT_TIMEZONES["America/Guadeloupe"] = "America/Guadeloupe";
    MOMENT_TIMEZONES["America/Guatemala"] = "America/Guatemala";
    MOMENT_TIMEZONES["America/Guayaquil"] = "America/Guayaquil";
    MOMENT_TIMEZONES["America/Guyana"] = "America/Guyana";
    MOMENT_TIMEZONES["America/Halifax"] = "America/Halifax";
    MOMENT_TIMEZONES["America/Havana"] = "America/Havana";
    MOMENT_TIMEZONES["America/Hermosillo"] = "America/Hermosillo";
    MOMENT_TIMEZONES["America/Indiana/Indianapolis"] = "America/Indiana/Indianapolis";
    MOMENT_TIMEZONES["America/Indiana/Knox"] = "America/Indiana/Knox";
    MOMENT_TIMEZONES["America/Indiana/Marengo"] = "America/Indiana/Marengo";
    MOMENT_TIMEZONES["America/Indiana/Petersburg"] = "America/Indiana/Petersburg";
    MOMENT_TIMEZONES["America/Indiana/Tell_City"] = "America/Indiana/Tell_City";
    MOMENT_TIMEZONES["America/Indiana/Vevay"] = "America/Indiana/Vevay";
    MOMENT_TIMEZONES["America/Indiana/Vincennes"] = "America/Indiana/Vincennes";
    MOMENT_TIMEZONES["America/Indiana/Winamac"] = "America/Indiana/Winamac";
    MOMENT_TIMEZONES["America/Indianapolis"] = "America/Indianapolis";
    MOMENT_TIMEZONES["America/Inuvik"] = "America/Inuvik";
    MOMENT_TIMEZONES["America/Iqaluit"] = "America/Iqaluit";
    MOMENT_TIMEZONES["America/Jamaica"] = "America/Jamaica";
    MOMENT_TIMEZONES["America/Juneau"] = "America/Juneau";
    MOMENT_TIMEZONES["America/Kentucky/Louisville"] = "America/Kentucky/Louisville";
    MOMENT_TIMEZONES["America/Kentucky/Monticello"] = "America/Kentucky/Monticello";
    MOMENT_TIMEZONES["America/Knox_IN"] = "America/Knox_IN";
    MOMENT_TIMEZONES["America/Kralendijk"] = "America/Kralendijk";
    MOMENT_TIMEZONES["America/La_Paz"] = "America/La_Paz";
    MOMENT_TIMEZONES["America/Lima"] = "America/Lima";
    MOMENT_TIMEZONES["America/Los_Angeles"] = "America/Los_Angeles";
    MOMENT_TIMEZONES["America/Louisville"] = "America/Louisville";
    MOMENT_TIMEZONES["America/Lower_Princes"] = "America/Lower_Princes";
    MOMENT_TIMEZONES["America/Maceio"] = "America/Maceio";
    MOMENT_TIMEZONES["America/Managua"] = "America/Managua";
    MOMENT_TIMEZONES["America/Manaus"] = "America/Manaus";
    MOMENT_TIMEZONES["America/Marigot"] = "America/Marigot";
    MOMENT_TIMEZONES["America/Martinique"] = "America/Martinique";
    MOMENT_TIMEZONES["America/Matamoros"] = "America/Matamoros";
    MOMENT_TIMEZONES["America/Mazatlan"] = "America/Mazatlan";
    MOMENT_TIMEZONES["America/Menominee"] = "America/Menominee";
    MOMENT_TIMEZONES["America/Merida"] = "America/Merida";
    MOMENT_TIMEZONES["America/Metlakatla"] = "America/Metlakatla";
    MOMENT_TIMEZONES["America/Mexico_City"] = "America/Mexico_City";
    MOMENT_TIMEZONES["America/Miquelon"] = "America/Miquelon";
    MOMENT_TIMEZONES["America/Moncton"] = "America/Moncton";
    MOMENT_TIMEZONES["America/Monterrey"] = "America/Monterrey";
    MOMENT_TIMEZONES["America/Montevideo"] = "America/Montevideo";
    MOMENT_TIMEZONES["America/Montreal"] = "America/Montreal";
    MOMENT_TIMEZONES["America/Montserrat"] = "America/Montserrat";
    MOMENT_TIMEZONES["America/Nassau"] = "America/Nassau";
    MOMENT_TIMEZONES["America/New_York"] = "America/New_York";
    MOMENT_TIMEZONES["America/Nipigon"] = "America/Nipigon";
    MOMENT_TIMEZONES["America/Nome"] = "America/Nome";
    MOMENT_TIMEZONES["America/Noronha"] = "America/Noronha";
    MOMENT_TIMEZONES["America/North_Dakota/Beulah"] = "America/North_Dakota/Beulah";
    MOMENT_TIMEZONES["America/North_Dakota/Center"] = "America/North_Dakota/Center";
    MOMENT_TIMEZONES["America/North_Dakota/New_Salem"] = "America/North_Dakota/New_Salem";
    MOMENT_TIMEZONES["America/Ojinaga"] = "America/Ojinaga";
    MOMENT_TIMEZONES["America/Panama"] = "America/Panama";
    MOMENT_TIMEZONES["America/Pangnirtung"] = "America/Pangnirtung";
    MOMENT_TIMEZONES["America/Paramaribo"] = "America/Paramaribo";
    MOMENT_TIMEZONES["America/Phoenix"] = "America/Phoenix";
    MOMENT_TIMEZONES["America/Port-au-Prince"] = "America/Port-au-Prince";
    MOMENT_TIMEZONES["America/Port_of_Spain"] = "America/Port_of_Spain";
    MOMENT_TIMEZONES["America/Porto_Acre"] = "America/Porto_Acre";
    MOMENT_TIMEZONES["America/Porto_Velho"] = "America/Porto_Velho";
    MOMENT_TIMEZONES["America/Puerto_Rico"] = "America/Puerto_Rico";
    MOMENT_TIMEZONES["America/Punta_Arenas"] = "America/Punta_Arenas";
    MOMENT_TIMEZONES["America/Rainy_River"] = "America/Rainy_River";
    MOMENT_TIMEZONES["America/Rankin_Inlet"] = "America/Rankin_Inlet";
    MOMENT_TIMEZONES["America/Recife"] = "America/Recife";
    MOMENT_TIMEZONES["America/Regina"] = "America/Regina";
    MOMENT_TIMEZONES["America/Resolute"] = "America/Resolute";
    MOMENT_TIMEZONES["America/Rio_Branco"] = "America/Rio_Branco";
    MOMENT_TIMEZONES["America/Rosario"] = "America/Rosario";
    MOMENT_TIMEZONES["America/Santa_Isabel"] = "America/Santa_Isabel";
    MOMENT_TIMEZONES["America/Santarem"] = "America/Santarem";
    MOMENT_TIMEZONES["America/Santiago"] = "America/Santiago";
    MOMENT_TIMEZONES["America/Santo_Domingo"] = "America/Santo_Domingo";
    MOMENT_TIMEZONES["America/Sao_Paulo"] = "America/Sao_Paulo";
    MOMENT_TIMEZONES["America/Scoresbysund"] = "America/Scoresbysund";
    MOMENT_TIMEZONES["America/Shiprock"] = "America/Shiprock";
    MOMENT_TIMEZONES["America/Sitka"] = "America/Sitka";
    MOMENT_TIMEZONES["America/St_Barthelemy"] = "America/St_Barthelemy";
    MOMENT_TIMEZONES["America/St_Johns"] = "America/St_Johns";
    MOMENT_TIMEZONES["America/St_Kitts"] = "America/St_Kitts";
    MOMENT_TIMEZONES["America/St_Lucia"] = "America/St_Lucia";
    MOMENT_TIMEZONES["America/St_Thomas"] = "America/St_Thomas";
    MOMENT_TIMEZONES["America/St_Vincent"] = "America/St_Vincent";
    MOMENT_TIMEZONES["America/Swift_Current"] = "America/Swift_Current";
    MOMENT_TIMEZONES["America/Tegucigalpa"] = "America/Tegucigalpa";
    MOMENT_TIMEZONES["America/Thule"] = "America/Thule";
    MOMENT_TIMEZONES["America/Thunder_Bay"] = "America/Thunder_Bay";
    MOMENT_TIMEZONES["America/Tijuana"] = "America/Tijuana";
    MOMENT_TIMEZONES["America/Toronto"] = "America/Toronto";
    MOMENT_TIMEZONES["America/Tortola"] = "America/Tortola";
    MOMENT_TIMEZONES["America/Vancouver"] = "America/Vancouver";
    MOMENT_TIMEZONES["America/Virgin"] = "America/Virgin";
    MOMENT_TIMEZONES["America/Whitehorse"] = "America/Whitehorse";
    MOMENT_TIMEZONES["America/Winnipeg"] = "America/Winnipeg";
    MOMENT_TIMEZONES["America/Yakutat"] = "America/Yakutat";
    MOMENT_TIMEZONES["America/Yellowknife"] = "America/Yellowknife";
    MOMENT_TIMEZONES["Antarctica/Casey"] = "Antarctica/Casey";
    MOMENT_TIMEZONES["Antarctica/Davis"] = "Antarctica/Davis";
    MOMENT_TIMEZONES["Antarctica/DumontDUrville"] = "Antarctica/DumontDUrville";
    MOMENT_TIMEZONES["Antarctica/Macquarie"] = "Antarctica/Macquarie";
    MOMENT_TIMEZONES["Antarctica/Mawson"] = "Antarctica/Mawson";
    MOMENT_TIMEZONES["Antarctica/McMurdo"] = "Antarctica/McMurdo";
    MOMENT_TIMEZONES["Antarctica/Palmer"] = "Antarctica/Palmer";
    MOMENT_TIMEZONES["Antarctica/Rothera"] = "Antarctica/Rothera";
    MOMENT_TIMEZONES["Antarctica/South_Pole"] = "Antarctica/South_Pole";
    MOMENT_TIMEZONES["Antarctica/Syowa"] = "Antarctica/Syowa";
    MOMENT_TIMEZONES["Antarctica/Troll"] = "Antarctica/Troll";
    MOMENT_TIMEZONES["Antarctica/Vostok"] = "Antarctica/Vostok";
    MOMENT_TIMEZONES["Arctic/Longyearbyen"] = "Arctic/Longyearbyen";
    MOMENT_TIMEZONES["Asia/Aden"] = "Asia/Aden";
    MOMENT_TIMEZONES["Asia/Almaty"] = "Asia/Almaty";
    MOMENT_TIMEZONES["Asia/Amman"] = "Asia/Amman";
    MOMENT_TIMEZONES["Asia/Anadyr"] = "Asia/Anadyr";
    MOMENT_TIMEZONES["Asia/Aqtau"] = "Asia/Aqtau";
    MOMENT_TIMEZONES["Asia/Aqtobe"] = "Asia/Aqtobe";
    MOMENT_TIMEZONES["Asia/Ashgabat"] = "Asia/Ashgabat";
    MOMENT_TIMEZONES["Asia/Ashkhabad"] = "Asia/Ashkhabad";
    MOMENT_TIMEZONES["Asia/Atyrau"] = "Asia/Atyrau";
    MOMENT_TIMEZONES["Asia/Baghdad"] = "Asia/Baghdad";
    MOMENT_TIMEZONES["Asia/Bahrain"] = "Asia/Bahrain";
    MOMENT_TIMEZONES["Asia/Baku"] = "Asia/Baku";
    MOMENT_TIMEZONES["Asia/Bangkok"] = "Asia/Bangkok";
    MOMENT_TIMEZONES["Asia/Barnaul"] = "Asia/Barnaul";
    MOMENT_TIMEZONES["Asia/Beirut"] = "Asia/Beirut";
    MOMENT_TIMEZONES["Asia/Bishkek"] = "Asia/Bishkek";
    MOMENT_TIMEZONES["Asia/Brunei"] = "Asia/Brunei";
    MOMENT_TIMEZONES["Asia/Calcutta"] = "Asia/Calcutta";
    MOMENT_TIMEZONES["Asia/Chita"] = "Asia/Chita";
    MOMENT_TIMEZONES["Asia/Choibalsan"] = "Asia/Choibalsan";
    MOMENT_TIMEZONES["Asia/Chongqing"] = "Asia/Chongqing";
    MOMENT_TIMEZONES["Asia/Chungking"] = "Asia/Chungking";
    MOMENT_TIMEZONES["Asia/Colombo"] = "Asia/Colombo";
    MOMENT_TIMEZONES["Asia/Dacca"] = "Asia/Dacca";
    MOMENT_TIMEZONES["Asia/Damascus"] = "Asia/Damascus";
    MOMENT_TIMEZONES["Asia/Dhaka"] = "Asia/Dhaka";
    MOMENT_TIMEZONES["Asia/Dili"] = "Asia/Dili";
    MOMENT_TIMEZONES["Asia/Dubai"] = "Asia/Dubai";
    MOMENT_TIMEZONES["Asia/Dushanbe"] = "Asia/Dushanbe";
    MOMENT_TIMEZONES["Asia/Famagusta"] = "Asia/Famagusta";
    MOMENT_TIMEZONES["Asia/Gaza"] = "Asia/Gaza";
    MOMENT_TIMEZONES["Asia/Harbin"] = "Asia/Harbin";
    MOMENT_TIMEZONES["Asia/Hebron"] = "Asia/Hebron";
    MOMENT_TIMEZONES["Asia/Ho_Chi_Minh"] = "Asia/Ho_Chi_Minh";
    MOMENT_TIMEZONES["Asia/Hong_Kong"] = "Asia/Hong_Kong";
    MOMENT_TIMEZONES["Asia/Hovd"] = "Asia/Hovd";
    MOMENT_TIMEZONES["Asia/Irkutsk"] = "Asia/Irkutsk";
    MOMENT_TIMEZONES["Asia/Istanbul"] = "Asia/Istanbul";
    MOMENT_TIMEZONES["Asia/Jakarta"] = "Asia/Jakarta";
    MOMENT_TIMEZONES["Asia/Jayapura"] = "Asia/Jayapura";
    MOMENT_TIMEZONES["Asia/Jerusalem"] = "Asia/Jerusalem";
    MOMENT_TIMEZONES["Asia/Kabul"] = "Asia/Kabul";
    MOMENT_TIMEZONES["Asia/Kamchatka"] = "Asia/Kamchatka";
    MOMENT_TIMEZONES["Asia/Karachi"] = "Asia/Karachi";
    MOMENT_TIMEZONES["Asia/Kashgar"] = "Asia/Kashgar";
    MOMENT_TIMEZONES["Asia/Kathmandu"] = "Asia/Kathmandu";
    MOMENT_TIMEZONES["Asia/Katmandu"] = "Asia/Katmandu";
    MOMENT_TIMEZONES["Asia/Khandyga"] = "Asia/Khandyga";
    MOMENT_TIMEZONES["Asia/Kolkata"] = "Asia/Kolkata";
    MOMENT_TIMEZONES["Asia/Krasnoyarsk"] = "Asia/Krasnoyarsk";
    MOMENT_TIMEZONES["Asia/Kuala_Lumpur"] = "Asia/Kuala_Lumpur";
    MOMENT_TIMEZONES["Asia/Kuching"] = "Asia/Kuching";
    MOMENT_TIMEZONES["Asia/Kuwait"] = "Asia/Kuwait";
    MOMENT_TIMEZONES["Asia/Macao"] = "Asia/Macao";
    MOMENT_TIMEZONES["Asia/Macau"] = "Asia/Macau";
    MOMENT_TIMEZONES["Asia/Magadan"] = "Asia/Magadan";
    MOMENT_TIMEZONES["Asia/Makassar"] = "Asia/Makassar";
    MOMENT_TIMEZONES["Asia/Manila"] = "Asia/Manila";
    MOMENT_TIMEZONES["Asia/Muscat"] = "Asia/Muscat";
    MOMENT_TIMEZONES["Asia/Nicosia"] = "Asia/Nicosia";
    MOMENT_TIMEZONES["Asia/Novokuznetsk"] = "Asia/Novokuznetsk";
    MOMENT_TIMEZONES["Asia/Novosibirsk"] = "Asia/Novosibirsk";
    MOMENT_TIMEZONES["Asia/Omsk"] = "Asia/Omsk";
    MOMENT_TIMEZONES["Asia/Oral"] = "Asia/Oral";
    MOMENT_TIMEZONES["Asia/Phnom_Penh"] = "Asia/Phnom_Penh";
    MOMENT_TIMEZONES["Asia/Pontianak"] = "Asia/Pontianak";
    MOMENT_TIMEZONES["Asia/Pyongyang"] = "Asia/Pyongyang";
    MOMENT_TIMEZONES["Asia/Qatar"] = "Asia/Qatar";
    MOMENT_TIMEZONES["Asia/Qostanay"] = "Asia/Qostanay";
    MOMENT_TIMEZONES["Asia/Qyzylorda"] = "Asia/Qyzylorda";
    MOMENT_TIMEZONES["Asia/Rangoon"] = "Asia/Rangoon";
    MOMENT_TIMEZONES["Asia/Riyadh"] = "Asia/Riyadh";
    MOMENT_TIMEZONES["Asia/Saigon"] = "Asia/Saigon";
    MOMENT_TIMEZONES["Asia/Sakhalin"] = "Asia/Sakhalin";
    MOMENT_TIMEZONES["Asia/Samarkand"] = "Asia/Samarkand";
    MOMENT_TIMEZONES["Asia/Seoul"] = "Asia/Seoul";
    MOMENT_TIMEZONES["Asia/Shanghai"] = "Asia/Shanghai";
    MOMENT_TIMEZONES["Asia/Singapore"] = "Asia/Singapore";
    MOMENT_TIMEZONES["Asia/Srednekolymsk"] = "Asia/Srednekolymsk";
    MOMENT_TIMEZONES["Asia/Taipei"] = "Asia/Taipei";
    MOMENT_TIMEZONES["Asia/Tashkent"] = "Asia/Tashkent";
    MOMENT_TIMEZONES["Asia/Tbilisi"] = "Asia/Tbilisi";
    MOMENT_TIMEZONES["Asia/Tehran"] = "Asia/Tehran";
    MOMENT_TIMEZONES["Asia/Tel_Aviv"] = "Asia/Tel_Aviv";
    MOMENT_TIMEZONES["Asia/Thimbu"] = "Asia/Thimbu";
    MOMENT_TIMEZONES["Asia/Thimphu"] = "Asia/Thimphu";
    MOMENT_TIMEZONES["Asia/Tokyo"] = "Asia/Tokyo";
    MOMENT_TIMEZONES["Asia/Tomsk"] = "Asia/Tomsk";
    MOMENT_TIMEZONES["Asia/Ujung_Pandang"] = "Asia/Ujung_Pandang";
    MOMENT_TIMEZONES["Asia/Ulaanbaatar"] = "Asia/Ulaanbaatar";
    MOMENT_TIMEZONES["Asia/Ulan_Bator"] = "Asia/Ulan_Bator";
    MOMENT_TIMEZONES["Asia/Urumqi"] = "Asia/Urumqi";
    MOMENT_TIMEZONES["Asia/Ust-Nera"] = "Asia/Ust-Nera";
    MOMENT_TIMEZONES["Asia/Vientiane"] = "Asia/Vientiane";
    MOMENT_TIMEZONES["Asia/Vladivostok"] = "Asia/Vladivostok";
    MOMENT_TIMEZONES["Asia/Yakutsk"] = "Asia/Yakutsk";
    MOMENT_TIMEZONES["Asia/Yangon"] = "Asia/Yangon";
    MOMENT_TIMEZONES["Asia/Yekaterinburg"] = "Asia/Yekaterinburg";
    MOMENT_TIMEZONES["Asia/Yerevan"] = "Asia/Yerevan";
    MOMENT_TIMEZONES["Atlantic/Azores"] = "Atlantic/Azores";
    MOMENT_TIMEZONES["Atlantic/Bermuda"] = "Atlantic/Bermuda";
    MOMENT_TIMEZONES["Atlantic/Canary"] = "Atlantic/Canary";
    MOMENT_TIMEZONES["Atlantic/Cape_Verde"] = "Atlantic/Cape_Verde";
    MOMENT_TIMEZONES["Atlantic/Faeroe"] = "Atlantic/Faeroe";
    MOMENT_TIMEZONES["Atlantic/Faroe"] = "Atlantic/Faroe";
    MOMENT_TIMEZONES["Atlantic/Jan_Mayen"] = "Atlantic/Jan_Mayen";
    MOMENT_TIMEZONES["Atlantic/Madeira"] = "Atlantic/Madeira";
    MOMENT_TIMEZONES["Atlantic/Reykjavik"] = "Atlantic/Reykjavik";
    MOMENT_TIMEZONES["Atlantic/South_Georgia"] = "Atlantic/South_Georgia";
    MOMENT_TIMEZONES["Atlantic/St_Helena"] = "Atlantic/St_Helena";
    MOMENT_TIMEZONES["Atlantic/Stanley"] = "Atlantic/Stanley";
    MOMENT_TIMEZONES["Australia/ACT"] = "Australia/ACT";
    MOMENT_TIMEZONES["Australia/Adelaide"] = "Australia/Adelaide";
    MOMENT_TIMEZONES["Australia/Brisbane"] = "Australia/Brisbane";
    MOMENT_TIMEZONES["Australia/Broken_Hill"] = "Australia/Broken_Hill";
    MOMENT_TIMEZONES["Australia/Canberra"] = "Australia/Canberra";
    MOMENT_TIMEZONES["Australia/Currie"] = "Australia/Currie";
    MOMENT_TIMEZONES["Australia/Darwin"] = "Australia/Darwin";
    MOMENT_TIMEZONES["Australia/Eucla"] = "Australia/Eucla";
    MOMENT_TIMEZONES["Australia/Hobart"] = "Australia/Hobart";
    MOMENT_TIMEZONES["Australia/LHI"] = "Australia/LHI";
    MOMENT_TIMEZONES["Australia/Lindeman"] = "Australia/Lindeman";
    MOMENT_TIMEZONES["Australia/Lord_Howe"] = "Australia/Lord_Howe";
    MOMENT_TIMEZONES["Australia/Melbourne"] = "Australia/Melbourne";
    MOMENT_TIMEZONES["Australia/NSW"] = "Australia/NSW";
    MOMENT_TIMEZONES["Australia/North"] = "Australia/North";
    MOMENT_TIMEZONES["Australia/Perth"] = "Australia/Perth";
    MOMENT_TIMEZONES["Australia/Queensland"] = "Australia/Queensland";
    MOMENT_TIMEZONES["Australia/South"] = "Australia/South";
    MOMENT_TIMEZONES["Australia/Sydney"] = "Australia/Sydney";
    MOMENT_TIMEZONES["Australia/Tasmania"] = "Australia/Tasmania";
    MOMENT_TIMEZONES["Australia/Victoria"] = "Australia/Victoria";
    MOMENT_TIMEZONES["Australia/West"] = "Australia/West";
    MOMENT_TIMEZONES["Australia/Yancowinna"] = "Australia/Yancowinna";
    MOMENT_TIMEZONES["Brazil/Acre"] = "Brazil/Acre";
    MOMENT_TIMEZONES["Brazil/DeNoronha"] = "Brazil/DeNoronha";
    MOMENT_TIMEZONES["Brazil/East"] = "Brazil/East";
    MOMENT_TIMEZONES["Brazil/West"] = "Brazil/West";
    MOMENT_TIMEZONES["CET"] = "CET";
    MOMENT_TIMEZONES["CST6CDT"] = "CST6CDT";
    MOMENT_TIMEZONES["Canada/Atlantic"] = "Canada/Atlantic";
    MOMENT_TIMEZONES["Canada/Central"] = "Canada/Central";
    MOMENT_TIMEZONES["Canada/Eastern"] = "Canada/Eastern";
    MOMENT_TIMEZONES["Canada/Mountain"] = "Canada/Mountain";
    MOMENT_TIMEZONES["Canada/Newfoundland"] = "Canada/Newfoundland";
    MOMENT_TIMEZONES["Canada/Pacific"] = "Canada/Pacific";
    MOMENT_TIMEZONES["Canada/Saskatchewan"] = "Canada/Saskatchewan";
    MOMENT_TIMEZONES["Canada/Yukon"] = "Canada/Yukon";
    MOMENT_TIMEZONES["Chile/Continental"] = "Chile/Continental";
    MOMENT_TIMEZONES["Chile/EasterIsland"] = "Chile/EasterIsland";
    MOMENT_TIMEZONES["Cuba"] = "Cuba";
    MOMENT_TIMEZONES["EET"] = "EET";
    MOMENT_TIMEZONES["EST"] = "EST";
    MOMENT_TIMEZONES["EST5EDT"] = "EST5EDT";
    MOMENT_TIMEZONES["Egypt"] = "Egypt";
    MOMENT_TIMEZONES["Eire"] = "Eire";
    MOMENT_TIMEZONES["Etc/GMT"] = "Etc/GMT";
    MOMENT_TIMEZONES["Etc/GMT+0"] = "Etc/GMT+0";
    MOMENT_TIMEZONES["Etc/GMT+1"] = "Etc/GMT+1";
    MOMENT_TIMEZONES["Etc/GMT+10"] = "Etc/GMT+10";
    MOMENT_TIMEZONES["Etc/GMT+11"] = "Etc/GMT+11";
    MOMENT_TIMEZONES["Etc/GMT+12"] = "Etc/GMT+12";
    MOMENT_TIMEZONES["Etc/GMT+2"] = "Etc/GMT+2";
    MOMENT_TIMEZONES["Etc/GMT+3"] = "Etc/GMT+3";
    MOMENT_TIMEZONES["Etc/GMT+4"] = "Etc/GMT+4";
    MOMENT_TIMEZONES["Etc/GMT+5"] = "Etc/GMT+5";
    MOMENT_TIMEZONES["Etc/GMT+6"] = "Etc/GMT+6";
    MOMENT_TIMEZONES["Etc/GMT+7"] = "Etc/GMT+7";
    MOMENT_TIMEZONES["Etc/GMT+8"] = "Etc/GMT+8";
    MOMENT_TIMEZONES["Etc/GMT+9"] = "Etc/GMT+9";
    MOMENT_TIMEZONES["Etc/GMT-0"] = "Etc/GMT-0";
    MOMENT_TIMEZONES["Etc/GMT-1"] = "Etc/GMT-1";
    MOMENT_TIMEZONES["Etc/GMT-10"] = "Etc/GMT-10";
    MOMENT_TIMEZONES["Etc/GMT-11"] = "Etc/GMT-11";
    MOMENT_TIMEZONES["Etc/GMT-12"] = "Etc/GMT-12";
    MOMENT_TIMEZONES["Etc/GMT-13"] = "Etc/GMT-13";
    MOMENT_TIMEZONES["Etc/GMT-14"] = "Etc/GMT-14";
    MOMENT_TIMEZONES["Etc/GMT-2"] = "Etc/GMT-2";
    MOMENT_TIMEZONES["Etc/GMT-3"] = "Etc/GMT-3";
    MOMENT_TIMEZONES["Etc/GMT-4"] = "Etc/GMT-4";
    MOMENT_TIMEZONES["Etc/GMT-5"] = "Etc/GMT-5";
    MOMENT_TIMEZONES["Etc/GMT-6"] = "Etc/GMT-6";
    MOMENT_TIMEZONES["Etc/GMT-7"] = "Etc/GMT-7";
    MOMENT_TIMEZONES["Etc/GMT-8"] = "Etc/GMT-8";
    MOMENT_TIMEZONES["Etc/GMT-9"] = "Etc/GMT-9";
    MOMENT_TIMEZONES["Etc/GMT0"] = "Etc/GMT0";
    MOMENT_TIMEZONES["Etc/Greenwich"] = "Etc/Greenwich";
    MOMENT_TIMEZONES["Etc/UCT"] = "Etc/UCT";
    MOMENT_TIMEZONES["Etc/UTC"] = "Etc/UTC";
    MOMENT_TIMEZONES["Etc/Universal"] = "Etc/Universal";
    MOMENT_TIMEZONES["Etc/Zulu"] = "Etc/Zulu";
    MOMENT_TIMEZONES["Europe/Amsterdam"] = "Europe/Amsterdam";
    MOMENT_TIMEZONES["Europe/Andorra"] = "Europe/Andorra";
    MOMENT_TIMEZONES["Europe/Astrakhan"] = "Europe/Astrakhan";
    MOMENT_TIMEZONES["Europe/Athens"] = "Europe/Athens";
    MOMENT_TIMEZONES["Europe/Belfast"] = "Europe/Belfast";
    MOMENT_TIMEZONES["Europe/Belgrade"] = "Europe/Belgrade";
    MOMENT_TIMEZONES["Europe/Berlin"] = "Europe/Berlin";
    MOMENT_TIMEZONES["Europe/Bratislava"] = "Europe/Bratislava";
    MOMENT_TIMEZONES["Europe/Brussels"] = "Europe/Brussels";
    MOMENT_TIMEZONES["Europe/Bucharest"] = "Europe/Bucharest";
    MOMENT_TIMEZONES["Europe/Budapest"] = "Europe/Budapest";
    MOMENT_TIMEZONES["Europe/Busingen"] = "Europe/Busingen";
    MOMENT_TIMEZONES["Europe/Chisinau"] = "Europe/Chisinau";
    MOMENT_TIMEZONES["Europe/Copenhagen"] = "Europe/Copenhagen";
    MOMENT_TIMEZONES["Europe/Dublin"] = "Europe/Dublin";
    MOMENT_TIMEZONES["Europe/Gibraltar"] = "Europe/Gibraltar";
    MOMENT_TIMEZONES["Europe/Guernsey"] = "Europe/Guernsey";
    MOMENT_TIMEZONES["Europe/Helsinki"] = "Europe/Helsinki";
    MOMENT_TIMEZONES["Europe/Isle_of_Man"] = "Europe/Isle_of_Man";
    MOMENT_TIMEZONES["Europe/Istanbul"] = "Europe/Istanbul";
    MOMENT_TIMEZONES["Europe/Jersey"] = "Europe/Jersey";
    MOMENT_TIMEZONES["Europe/Kaliningrad"] = "Europe/Kaliningrad";
    MOMENT_TIMEZONES["Europe/Kiev"] = "Europe/Kiev";
    MOMENT_TIMEZONES["Europe/Kirov"] = "Europe/Kirov";
    MOMENT_TIMEZONES["Europe/Lisbon"] = "Europe/Lisbon";
    MOMENT_TIMEZONES["Europe/Ljubljana"] = "Europe/Ljubljana";
    MOMENT_TIMEZONES["Europe/London"] = "Europe/London";
    MOMENT_TIMEZONES["Europe/Luxembourg"] = "Europe/Luxembourg";
    MOMENT_TIMEZONES["Europe/Madrid"] = "Europe/Madrid";
    MOMENT_TIMEZONES["Europe/Malta"] = "Europe/Malta";
    MOMENT_TIMEZONES["Europe/Mariehamn"] = "Europe/Mariehamn";
    MOMENT_TIMEZONES["Europe/Minsk"] = "Europe/Minsk";
    MOMENT_TIMEZONES["Europe/Monaco"] = "Europe/Monaco";
    MOMENT_TIMEZONES["Europe/Moscow"] = "Europe/Moscow";
    MOMENT_TIMEZONES["Europe/Nicosia"] = "Europe/Nicosia";
    MOMENT_TIMEZONES["Europe/Oslo"] = "Europe/Oslo";
    MOMENT_TIMEZONES["Europe/Paris"] = "Europe/Paris";
    MOMENT_TIMEZONES["Europe/Podgorica"] = "Europe/Podgorica";
    MOMENT_TIMEZONES["Europe/Prague"] = "Europe/Prague";
    MOMENT_TIMEZONES["Europe/Riga"] = "Europe/Riga";
    MOMENT_TIMEZONES["Europe/Rome"] = "Europe/Rome";
    MOMENT_TIMEZONES["Europe/Samara"] = "Europe/Samara";
    MOMENT_TIMEZONES["Europe/San_Marino"] = "Europe/San_Marino";
    MOMENT_TIMEZONES["Europe/Sarajevo"] = "Europe/Sarajevo";
    MOMENT_TIMEZONES["Europe/Saratov"] = "Europe/Saratov";
    MOMENT_TIMEZONES["Europe/Simferopol"] = "Europe/Simferopol";
    MOMENT_TIMEZONES["Europe/Skopje"] = "Europe/Skopje";
    MOMENT_TIMEZONES["Europe/Sofia"] = "Europe/Sofia";
    MOMENT_TIMEZONES["Europe/Stockholm"] = "Europe/Stockholm";
    MOMENT_TIMEZONES["Europe/Tallinn"] = "Europe/Tallinn";
    MOMENT_TIMEZONES["Europe/Tirane"] = "Europe/Tirane";
    MOMENT_TIMEZONES["Europe/Tiraspol"] = "Europe/Tiraspol";
    MOMENT_TIMEZONES["Europe/Ulyanovsk"] = "Europe/Ulyanovsk";
    MOMENT_TIMEZONES["Europe/Uzhgorod"] = "Europe/Uzhgorod";
    MOMENT_TIMEZONES["Europe/Vaduz"] = "Europe/Vaduz";
    MOMENT_TIMEZONES["Europe/Vatican"] = "Europe/Vatican";
    MOMENT_TIMEZONES["Europe/Vienna"] = "Europe/Vienna";
    MOMENT_TIMEZONES["Europe/Vilnius"] = "Europe/Vilnius";
    MOMENT_TIMEZONES["Europe/Volgograd"] = "Europe/Volgograd";
    MOMENT_TIMEZONES["Europe/Warsaw"] = "Europe/Warsaw";
    MOMENT_TIMEZONES["Europe/Zagreb"] = "Europe/Zagreb";
    MOMENT_TIMEZONES["Europe/Zaporozhye"] = "Europe/Zaporozhye";
    MOMENT_TIMEZONES["Europe/Zurich"] = "Europe/Zurich";
    MOMENT_TIMEZONES["Europe/Kyiv"] = "Europe/Kyiv";
    MOMENT_TIMEZONES["GB"] = "GB";
    MOMENT_TIMEZONES["GB-Eire"] = "GB-Eire";
    MOMENT_TIMEZONES["GMT"] = "GMT";
    MOMENT_TIMEZONES["GMT+0"] = "GMT+0";
    MOMENT_TIMEZONES["GMT-0"] = "GMT-0";
    MOMENT_TIMEZONES["GMT0"] = "GMT0";
    MOMENT_TIMEZONES["Greenwich"] = "Greenwich";
    MOMENT_TIMEZONES["HST"] = "HST";
    MOMENT_TIMEZONES["Hongkong"] = "Hongkong";
    MOMENT_TIMEZONES["Iceland"] = "Iceland";
    MOMENT_TIMEZONES["Indian/Antananarivo"] = "Indian/Antananarivo";
    MOMENT_TIMEZONES["Indian/Chagos"] = "Indian/Chagos";
    MOMENT_TIMEZONES["Indian/Christmas"] = "Indian/Christmas";
    MOMENT_TIMEZONES["Indian/Cocos"] = "Indian/Cocos";
    MOMENT_TIMEZONES["Indian/Comoro"] = "Indian/Comoro";
    MOMENT_TIMEZONES["Indian/Kerguelen"] = "Indian/Kerguelen";
    MOMENT_TIMEZONES["Indian/Mahe"] = "Indian/Mahe";
    MOMENT_TIMEZONES["Indian/Maldives"] = "Indian/Maldives";
    MOMENT_TIMEZONES["Indian/Mauritius"] = "Indian/Mauritius";
    MOMENT_TIMEZONES["Indian/Mayotte"] = "Indian/Mayotte";
    MOMENT_TIMEZONES["Indian/Reunion"] = "Indian/Reunion";
    MOMENT_TIMEZONES["Iran"] = "Iran";
    MOMENT_TIMEZONES["Israel"] = "Israel";
    MOMENT_TIMEZONES["Jamaica"] = "Jamaica";
    MOMENT_TIMEZONES["Japan"] = "Japan";
    MOMENT_TIMEZONES["Kwajalein"] = "Kwajalein";
    MOMENT_TIMEZONES["Libya"] = "Libya";
    MOMENT_TIMEZONES["MET"] = "MET";
    MOMENT_TIMEZONES["MST"] = "MST";
    MOMENT_TIMEZONES["MST7MDT"] = "MST7MDT";
    MOMENT_TIMEZONES["Mexico/BajaNorte"] = "Mexico/BajaNorte";
    MOMENT_TIMEZONES["Mexico/BajaSur"] = "Mexico/BajaSur";
    MOMENT_TIMEZONES["Mexico/General"] = "Mexico/General";
    MOMENT_TIMEZONES["NZ"] = "NZ";
    MOMENT_TIMEZONES["NZ-CHAT"] = "NZ-CHAT";
    MOMENT_TIMEZONES["Navajo"] = "Navajo";
    MOMENT_TIMEZONES["PRC"] = "PRC";
    MOMENT_TIMEZONES["PST8PDT"] = "PST8PDT";
    MOMENT_TIMEZONES["Pacific/Apia"] = "Pacific/Apia";
    MOMENT_TIMEZONES["Pacific/Auckland"] = "Pacific/Auckland";
    MOMENT_TIMEZONES["Pacific/Bougainville"] = "Pacific/Bougainville";
    MOMENT_TIMEZONES["Pacific/Chatham"] = "Pacific/Chatham";
    MOMENT_TIMEZONES["Pacific/Chuuk"] = "Pacific/Chuuk";
    MOMENT_TIMEZONES["Pacific/Easter"] = "Pacific/Easter";
    MOMENT_TIMEZONES["Pacific/Efate"] = "Pacific/Efate";
    MOMENT_TIMEZONES["Pacific/Enderbury"] = "Pacific/Enderbury";
    MOMENT_TIMEZONES["Pacific/Fakaofo"] = "Pacific/Fakaofo";
    MOMENT_TIMEZONES["Pacific/Fiji"] = "Pacific/Fiji";
    MOMENT_TIMEZONES["Pacific/Funafuti"] = "Pacific/Funafuti";
    MOMENT_TIMEZONES["Pacific/Galapagos"] = "Pacific/Galapagos";
    MOMENT_TIMEZONES["Pacific/Gambier"] = "Pacific/Gambier";
    MOMENT_TIMEZONES["Pacific/Guadalcanal"] = "Pacific/Guadalcanal";
    MOMENT_TIMEZONES["Pacific/Guam"] = "Pacific/Guam";
    MOMENT_TIMEZONES["Pacific/Honolulu"] = "Pacific/Honolulu";
    MOMENT_TIMEZONES["Pacific/Johnston"] = "Pacific/Johnston";
    MOMENT_TIMEZONES["Pacific/Kiritimati"] = "Pacific/Kiritimati";
    MOMENT_TIMEZONES["Pacific/Kosrae"] = "Pacific/Kosrae";
    MOMENT_TIMEZONES["Pacific/Kwajalein"] = "Pacific/Kwajalein";
    MOMENT_TIMEZONES["Pacific/Majuro"] = "Pacific/Majuro";
    MOMENT_TIMEZONES["Pacific/Marquesas"] = "Pacific/Marquesas";
    MOMENT_TIMEZONES["Pacific/Midway"] = "Pacific/Midway";
    MOMENT_TIMEZONES["Pacific/Nauru"] = "Pacific/Nauru";
    MOMENT_TIMEZONES["Pacific/Niue"] = "Pacific/Niue";
    MOMENT_TIMEZONES["Pacific/Norfolk"] = "Pacific/Norfolk";
    MOMENT_TIMEZONES["Pacific/Noumea"] = "Pacific/Noumea";
    MOMENT_TIMEZONES["Pacific/Pago_Pago"] = "Pacific/Pago_Pago";
    MOMENT_TIMEZONES["Pacific/Palau"] = "Pacific/Palau";
    MOMENT_TIMEZONES["Pacific/Pitcairn"] = "Pacific/Pitcairn";
    MOMENT_TIMEZONES["Pacific/Pohnpei"] = "Pacific/Pohnpei";
    MOMENT_TIMEZONES["Pacific/Ponape"] = "Pacific/Ponape";
    MOMENT_TIMEZONES["Pacific/Port_Moresby"] = "Pacific/Port_Moresby";
    MOMENT_TIMEZONES["Pacific/Rarotonga"] = "Pacific/Rarotonga";
    MOMENT_TIMEZONES["Pacific/Saipan"] = "Pacific/Saipan";
    MOMENT_TIMEZONES["Pacific/Samoa"] = "Pacific/Samoa";
    MOMENT_TIMEZONES["Pacific/Tahiti"] = "Pacific/Tahiti";
    MOMENT_TIMEZONES["Pacific/Tarawa"] = "Pacific/Tarawa";
    MOMENT_TIMEZONES["Pacific/Tongatapu"] = "Pacific/Tongatapu";
    MOMENT_TIMEZONES["Pacific/Truk"] = "Pacific/Truk";
    MOMENT_TIMEZONES["Pacific/Wake"] = "Pacific/Wake";
    MOMENT_TIMEZONES["Pacific/Wallis"] = "Pacific/Wallis";
    MOMENT_TIMEZONES["Pacific/Yap"] = "Pacific/Yap";
    MOMENT_TIMEZONES["Poland"] = "Poland";
    MOMENT_TIMEZONES["Portugal"] = "Portugal";
    MOMENT_TIMEZONES["ROC"] = "ROC";
    MOMENT_TIMEZONES["ROK"] = "ROK";
    MOMENT_TIMEZONES["Singapore"] = "Singapore";
    MOMENT_TIMEZONES["Turkey"] = "Turkey";
    MOMENT_TIMEZONES["UCT"] = "UCT";
    MOMENT_TIMEZONES["US/Alaska"] = "US/Alaska";
    MOMENT_TIMEZONES["US/Aleutian"] = "US/Aleutian";
    MOMENT_TIMEZONES["US/Arizona"] = "US/Arizona";
    MOMENT_TIMEZONES["US/Central"] = "US/Central";
    MOMENT_TIMEZONES["US/East-Indiana"] = "US/East-Indiana";
    MOMENT_TIMEZONES["US/Eastern"] = "US/Eastern";
    MOMENT_TIMEZONES["US/Hawaii"] = "US/Hawaii";
    MOMENT_TIMEZONES["US/Indiana-Starke"] = "US/Indiana-Starke";
    MOMENT_TIMEZONES["US/Michigan"] = "US/Michigan";
    MOMENT_TIMEZONES["US/Mountain"] = "US/Mountain";
    MOMENT_TIMEZONES["US/Pacific"] = "US/Pacific";
    MOMENT_TIMEZONES["US/Pacific-New"] = "US/Pacific-New";
    MOMENT_TIMEZONES["US/Samoa"] = "US/Samoa";
    MOMENT_TIMEZONES["UTC"] = "UTC";
    MOMENT_TIMEZONES["Universal"] = "Universal";
    MOMENT_TIMEZONES["W-SU"] = "W-SU";
    MOMENT_TIMEZONES["WET"] = "WET";
    MOMENT_TIMEZONES["Zulu"] = "Zulu";
})(MOMENT_TIMEZONES || (exports.MOMENT_TIMEZONES = MOMENT_TIMEZONES = {}));
var TIMEZONE;
(function (TIMEZONE) {
    TIMEZONE["UTCM12"] = "UTCM12";
    TIMEZONE["UTCM11"] = "UTCM11";
    TIMEZONE["UTCM10"] = "UTCM10";
    TIMEZONE["DST"] = "DST";
    TIMEZONE["U"] = "U";
    TIMEZONE["HST"] = "HST";
    TIMEZONE["HDT"] = "HDT";
    TIMEZONE["MART"] = "MART";
    TIMEZONE["AKDT"] = "AKDT";
    TIMEZONE["UTCM9"] = "UTCM9";
    TIMEZONE["PT"] = "PT";
    TIMEZONE["UTCM8"] = "UTCM8";
    TIMEZONE["UTCM7"] = "UTCM7";
    TIMEZONE["UTCM6"] = "UTCM6";
    TIMEZONE["MT"] = "MT";
    TIMEZONE["AZ"] = "AZ";
    TIMEZONE["CO"] = "CO";
    TIMEZONE["YT"] = "YT";
    TIMEZONE["SI"] = "SI";
    TIMEZONE["CT"] = "CT";
    TIMEZONE["SK"] = "SK";
    TIMEZONE["EI"] = "EI";
    TIMEZONE["UTCM5"] = "UTCM5";
    TIMEZONE["ET"] = "ET";
    TIMEZONE["UTCM4"] = "UTCM4";
    TIMEZONE["AT"] = "AT";
    TIMEZONE["NL"] = "NL";
    TIMEZONE["UTCM3"] = "UTCM3";
    TIMEZONE["GL"] = "GL";
    TIMEZONE["UTCM2"] = "UTCM2";
    TIMEZONE["UTCM1"] = "UTCM1";
    TIMEZONE["AZOT"] = "AZOT";
    TIMEZONE["UTC"] = "UTC";
    TIMEZONE["BT"] = "BT";
    TIMEZONE["MA"] = "MA";
    TIMEZONE["UTC1"] = "UTC1";
    TIMEZONE["WAT"] = "WAT";
    TIMEZONE["CET"] = "CET";
    TIMEZONE["EET"] = "EET";
    TIMEZONE["UTC2"] = "UTC2";
    TIMEZONE["EAT"] = "EAT";
    TIMEZONE["UTC3"] = "UTC3";
    TIMEZONE["MSK"] = "MSK";
    TIMEZONE["IRST"] = "IRST";
    TIMEZONE["UTC4"] = "UTC4";
    TIMEZONE["AFT"] = "AFT";
    TIMEZONE["UTC5"] = "UTC5";
    TIMEZONE["IST"] = "IST";
    TIMEZONE["NPT"] = "NPT";
    TIMEZONE["UTC6"] = "UTC6";
    TIMEZONE["MMT"] = "MMT";
    TIMEZONE["ICT"] = "ICT";
    TIMEZONE["UTC7"] = "UTC7";
    TIMEZONE["CST"] = "CST";
    TIMEZONE["UTC8"] = "UTC8";
    TIMEZONE["EUCLA"] = "EUCLA";
    TIMEZONE["UTC9"] = "UTC9";
    TIMEZONE["ADLD"] = "ADLD";
    TIMEZONE["DRWN"] = "DRWN";
    TIMEZONE["BRSB"] = "BRSB";
    TIMEZONE["MLBRN"] = "MLBRN";
    TIMEZONE["UTC10"] = "UTC10";
    TIMEZONE["LHT"] = "LHT";
    TIMEZONE["NFT"] = "NFT";
    TIMEZONE["UTC11"] = "UTC11";
    TIMEZONE["NZT"] = "NZT";
    TIMEZONE["UTC12"] = "UTC12";
    TIMEZONE["CHAT"] = "CHAT";
    TIMEZONE["TOT"] = "TOT";
    TIMEZONE["UTC13"] = "UTC13";
    TIMEZONE["UTC14"] = "UTC14";
    /**
     * @deprecated
     */
    TIMEZONE["NZDT"] = "NZDT";
    /**
     * @deprecated
     */
    TIMEZONE["IDLE"] = "IDLE";
    /**
     * @deprecated
     */
    TIMEZONE["NZST"] = "NZST";
    /**
     * @deprecated
     */
    TIMEZONE["AESST"] = "AESST";
    /**
     * @deprecated
     */
    TIMEZONE["ACSST"] = "ACSST";
    /**
     * @deprecated
     */
    TIMEZONE["CADT"] = "CADT";
    /**
     * @deprecated
     */
    TIMEZONE["SADT"] = "SADT";
    /**
     * @deprecated
     */
    TIMEZONE["AEST"] = "AEST";
    /**
     * @deprecated
     */
    TIMEZONE["EAST"] = "EAST";
    /**
     * @deprecated
     */
    TIMEZONE["GST"] = "GST";
    /**
     * @deprecated
     */
    TIMEZONE["LIGT"] = "LIGT";
    /**
     * @deprecated
     */
    TIMEZONE["SAST"] = "SAST";
    /**
     * @deprecated
     */
    TIMEZONE["CAST"] = "CAST";
    /**
     * @deprecated
     */
    TIMEZONE["AWSST"] = "AWSST";
    /**
     * @deprecated
     */
    TIMEZONE["JST"] = "JST";
    /**
     * @deprecated
     */
    TIMEZONE["KST"] = "KST";
    /**
     * @deprecated
     */
    TIMEZONE["MHT"] = "MHT";
    /**
     * @deprecated
     */
    TIMEZONE["WDT"] = "WDT";
    /**
     * @deprecated
     */
    TIMEZONE["AWST"] = "AWST";
    /**
     * @deprecated
     */
    TIMEZONE["CCT"] = "CCT";
    /**
     * @deprecated
     */
    TIMEZONE["WADT"] = "WADT";
    /**
     * @deprecated
     */
    TIMEZONE["WST"] = "WST";
    /**
     * @deprecated
     */
    TIMEZONE["JT"] = "JT";
    /**
     * @deprecated
     */
    TIMEZONE["ALMST"] = "ALMST";
    /**
     * @deprecated
     */
    TIMEZONE["WAST"] = "WAST";
    /**
     * @deprecated
     */
    TIMEZONE["CXT"] = "CXT";
    /**
     * @deprecated
     */
    TIMEZONE["ALMT"] = "ALMT";
    /**
     * @deprecated
     */
    TIMEZONE["MAWT"] = "MAWT";
    /**
     * @deprecated
     */
    TIMEZONE["IOT"] = "IOT";
    /**
     * @deprecated
     */
    TIMEZONE["MVT"] = "MVT";
    /**
     * @deprecated
     */
    TIMEZONE["TFT"] = "TFT";
    /**
     * @deprecated
     */
    TIMEZONE["MUT"] = "MUT";
    /**
     * @deprecated
     */
    TIMEZONE["RET"] = "RET";
    /**
     * @deprecated
     */
    TIMEZONE["SCT"] = "SCT";
    /**
     * @deprecated
     */
    TIMEZONE["IT"] = "IT";
    /**
     * @deprecated
     */
    TIMEZONE["EETDST"] = "EETDST";
    /**
     * @deprecated
     */
    TIMEZONE["HMT"] = "HMT";
    /**
     * @deprecated
     */
    TIMEZONE["BDST"] = "BDST";
    /**
     * @deprecated
     */
    TIMEZONE["CEST"] = "CEST";
    /**
     * @deprecated
     */
    TIMEZONE["CETDST"] = "CETDST";
    /**
     * @deprecated
     */
    TIMEZONE["FWT"] = "FWT";
    /**
     * @deprecated
     */
    TIMEZONE["MEST"] = "MEST";
    /**
     * @deprecated
     */
    TIMEZONE["METDST"] = "METDST";
    /**
     * @deprecated
     */
    TIMEZONE["SST"] = "SST";
    /**
     * @deprecated
     */
    TIMEZONE["BST"] = "BST";
    /**
     * @deprecated
     */
    TIMEZONE["DNT"] = "DNT";
    /**
     * @deprecated
     */
    TIMEZONE["FST"] = "FST";
    /**
     * @deprecated
     */
    TIMEZONE["MET"] = "MET";
    /**
     * @deprecated
     */
    TIMEZONE["MEWT"] = "MEWT";
    /**
     * @deprecated
     */
    TIMEZONE["MEZ"] = "MEZ";
    /**
     * @deprecated
     */
    TIMEZONE["NOR"] = "NOR";
    /**
     * @deprecated
     */
    TIMEZONE["SET"] = "SET";
    /**
     * @deprecated
     */
    TIMEZONE["SWT"] = "SWT";
    /**
     * @deprecated
     */
    TIMEZONE["WETDST"] = "WETDST";
    /**
     * @deprecated
     */
    TIMEZONE["GMT"] = "GMT";
    /**
     * @deprecated
     */
    TIMEZONE["UT"] = "UT";
    /**
     * @deprecated
     */
    TIMEZONE["Z"] = "Z";
    /**
     * @deprecated
     */
    TIMEZONE["ZULU"] = "ZULU";
    /**
     * @deprecated
     */
    TIMEZONE["WET"] = "WET";
    /**
     * @deprecated
     */
    TIMEZONE["NDT"] = "NDT";
    /**
     * @deprecated
     */
    TIMEZONE["ADT"] = "ADT";
    /**
     * @deprecated
     */
    TIMEZONE["AWT"] = "AWT";
    /**
     * @deprecated
     */
    TIMEZONE["NST"] = "NST";
    /**
     * @deprecated
     */
    TIMEZONE["AST"] = "AST";
    /**
     * @deprecated
     */
    TIMEZONE["ACST"] = "ACST";
    /**
     * @deprecated
     */
    TIMEZONE["ACT"] = "ACT";
    /**
     * @deprecated
     */
    TIMEZONE["EDT"] = "EDT";
    /**
     * @deprecated
     */
    TIMEZONE["CDT"] = "CDT";
    /**
     * @deprecated
     */
    TIMEZONE["EST"] = "EST";
    /**
     * @deprecated
     */
    TIMEZONE["MDT"] = "MDT";
    /**
     * @deprecated
     */
    TIMEZONE["MST"] = "MST";
    /**
     * @deprecated
     */
    TIMEZONE["PDT"] = "PDT";
    /**
     * @deprecated
     */
    TIMEZONE["PST"] = "PST";
    /**
     * @deprecated
     */
    TIMEZONE["YDT"] = "YDT";
    /**
     * @deprecated
     */
    TIMEZONE["AKST"] = "AKST";
    /**
     * @deprecated
     */
    TIMEZONE["YST"] = "YST";
    /**
     * @deprecated
     */
    TIMEZONE["AHST"] = "AHST";
    /**
     * @deprecated
     */
    TIMEZONE["CAT"] = "CAT";
    /**
     * @deprecated
     */
    TIMEZONE["NT"] = "NT";
    /**
     * @deprecated
     */
    TIMEZONE["IDLW"] = "IDLW";
})(TIMEZONE || (exports.TIMEZONE = TIMEZONE = {}));
/**
 * @deprecated Use TIMEZONE instead
 * this is used in the frontend to know which keys not to display as options
 */
var DEPRECATED_TIMEZONE_KEYS;
(function (DEPRECATED_TIMEZONE_KEYS) {
    DEPRECATED_TIMEZONE_KEYS["NZDT"] = "NZDT";
    DEPRECATED_TIMEZONE_KEYS["IDLE"] = "IDLE";
    DEPRECATED_TIMEZONE_KEYS["NZST"] = "NZST";
    DEPRECATED_TIMEZONE_KEYS["AESST"] = "AESST";
    DEPRECATED_TIMEZONE_KEYS["ACSST"] = "ACSST";
    DEPRECATED_TIMEZONE_KEYS["CADT"] = "CADT";
    DEPRECATED_TIMEZONE_KEYS["SADT"] = "SADT";
    DEPRECATED_TIMEZONE_KEYS["AEST"] = "AEST";
    DEPRECATED_TIMEZONE_KEYS["EAST"] = "EAST";
    DEPRECATED_TIMEZONE_KEYS["GST"] = "GST";
    DEPRECATED_TIMEZONE_KEYS["LIGT"] = "LIGT";
    DEPRECATED_TIMEZONE_KEYS["SAST"] = "SAST";
    DEPRECATED_TIMEZONE_KEYS["CAST"] = "CAST";
    DEPRECATED_TIMEZONE_KEYS["AWSST"] = "AWSST";
    DEPRECATED_TIMEZONE_KEYS["JST"] = "JST";
    DEPRECATED_TIMEZONE_KEYS["KST"] = "KST";
    DEPRECATED_TIMEZONE_KEYS["MHT"] = "MHT";
    DEPRECATED_TIMEZONE_KEYS["WDT"] = "WDT";
    DEPRECATED_TIMEZONE_KEYS["AWST"] = "AWST";
    DEPRECATED_TIMEZONE_KEYS["CCT"] = "CCT";
    DEPRECATED_TIMEZONE_KEYS["WADT"] = "WADT";
    DEPRECATED_TIMEZONE_KEYS["WST"] = "WST";
    DEPRECATED_TIMEZONE_KEYS["JT"] = "JT";
    DEPRECATED_TIMEZONE_KEYS["ALMST"] = "ALMST";
    DEPRECATED_TIMEZONE_KEYS["WAST"] = "WAST";
    DEPRECATED_TIMEZONE_KEYS["CXT"] = "CXT";
    DEPRECATED_TIMEZONE_KEYS["ALMT"] = "ALMT";
    DEPRECATED_TIMEZONE_KEYS["MAWT"] = "MAWT";
    DEPRECATED_TIMEZONE_KEYS["IOT"] = "IOT";
    DEPRECATED_TIMEZONE_KEYS["MVT"] = "MVT";
    DEPRECATED_TIMEZONE_KEYS["TFT"] = "TFT";
    DEPRECATED_TIMEZONE_KEYS["MUT"] = "MUT";
    DEPRECATED_TIMEZONE_KEYS["RET"] = "RET";
    DEPRECATED_TIMEZONE_KEYS["SCT"] = "SCT";
    DEPRECATED_TIMEZONE_KEYS["IT"] = "IT";
    DEPRECATED_TIMEZONE_KEYS["EETDST"] = "EETDST";
    DEPRECATED_TIMEZONE_KEYS["HMT"] = "HMT";
    DEPRECATED_TIMEZONE_KEYS["BDST"] = "BDST";
    DEPRECATED_TIMEZONE_KEYS["CEST"] = "CEST";
    DEPRECATED_TIMEZONE_KEYS["CETDST"] = "CETDST";
    DEPRECATED_TIMEZONE_KEYS["FWT"] = "FWT";
    DEPRECATED_TIMEZONE_KEYS["MEST"] = "MEST";
    DEPRECATED_TIMEZONE_KEYS["METDST"] = "METDST";
    DEPRECATED_TIMEZONE_KEYS["SST"] = "SST";
    DEPRECATED_TIMEZONE_KEYS["BST"] = "BST";
    DEPRECATED_TIMEZONE_KEYS["DNT"] = "DNT";
    DEPRECATED_TIMEZONE_KEYS["FST"] = "FST";
    DEPRECATED_TIMEZONE_KEYS["MET"] = "MET";
    DEPRECATED_TIMEZONE_KEYS["MEWT"] = "MEWT";
    DEPRECATED_TIMEZONE_KEYS["MEZ"] = "MEZ";
    DEPRECATED_TIMEZONE_KEYS["NOR"] = "NOR";
    DEPRECATED_TIMEZONE_KEYS["SET"] = "SET";
    DEPRECATED_TIMEZONE_KEYS["SWT"] = "SWT";
    DEPRECATED_TIMEZONE_KEYS["WETDST"] = "WETDST";
    DEPRECATED_TIMEZONE_KEYS["GMT"] = "GMT";
    DEPRECATED_TIMEZONE_KEYS["UT"] = "UT";
    DEPRECATED_TIMEZONE_KEYS["Z"] = "Z";
    DEPRECATED_TIMEZONE_KEYS["ZULU"] = "ZULU";
    DEPRECATED_TIMEZONE_KEYS["WET"] = "WET";
    DEPRECATED_TIMEZONE_KEYS["NDT"] = "NDT";
    DEPRECATED_TIMEZONE_KEYS["ADT"] = "ADT";
    DEPRECATED_TIMEZONE_KEYS["AWT"] = "AWT";
    DEPRECATED_TIMEZONE_KEYS["NST"] = "NST";
    DEPRECATED_TIMEZONE_KEYS["AST"] = "AST";
    DEPRECATED_TIMEZONE_KEYS["ACST"] = "ACST";
    DEPRECATED_TIMEZONE_KEYS["ACT"] = "ACT";
    DEPRECATED_TIMEZONE_KEYS["EDT"] = "EDT";
    DEPRECATED_TIMEZONE_KEYS["CDT"] = "CDT";
    DEPRECATED_TIMEZONE_KEYS["EST"] = "EST";
    DEPRECATED_TIMEZONE_KEYS["MDT"] = "MDT";
    DEPRECATED_TIMEZONE_KEYS["MST"] = "MST";
    DEPRECATED_TIMEZONE_KEYS["PDT"] = "PDT";
    DEPRECATED_TIMEZONE_KEYS["PST"] = "PST";
    DEPRECATED_TIMEZONE_KEYS["YDT"] = "YDT";
    DEPRECATED_TIMEZONE_KEYS["AKST"] = "AKST";
    DEPRECATED_TIMEZONE_KEYS["YST"] = "YST";
    DEPRECATED_TIMEZONE_KEYS["AHST"] = "AHST";
    DEPRECATED_TIMEZONE_KEYS["CAT"] = "CAT";
    DEPRECATED_TIMEZONE_KEYS["NT"] = "NT";
    DEPRECATED_TIMEZONE_KEYS["IDLW"] = "IDLW";
})(DEPRECATED_TIMEZONE_KEYS || (exports.DEPRECATED_TIMEZONE_KEYS = DEPRECATED_TIMEZONE_KEYS = {}));
var TIMEZONES_MIGRATION_MAP;
(function (TIMEZONES_MIGRATION_MAP) {
    TIMEZONES_MIGRATION_MAP["NZDT"] = "UTC13";
    TIMEZONES_MIGRATION_MAP["IDLE"] = "UTC12";
    TIMEZONES_MIGRATION_MAP["NZST"] = "UTC12";
    TIMEZONES_MIGRATION_MAP["NZT"] = "UTC12";
    TIMEZONES_MIGRATION_MAP["AESST"] = "UTC11";
    TIMEZONES_MIGRATION_MAP["ACSST"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["CADT"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["SADT"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["AEST"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["EAST"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["GST"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["LIGT"] = "UTC10";
    TIMEZONES_MIGRATION_MAP["SAST"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["CAST"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["AWSST"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["JST"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["KST"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["MHT"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["WDT"] = "UTC9";
    TIMEZONES_MIGRATION_MAP["MT"] = "UTC8";
    TIMEZONES_MIGRATION_MAP["AWST"] = "UTC8";
    TIMEZONES_MIGRATION_MAP["CCT"] = "UTC8";
    TIMEZONES_MIGRATION_MAP["WADT"] = "UTC8";
    TIMEZONES_MIGRATION_MAP["WST"] = "UTC8";
    TIMEZONES_MIGRATION_MAP["JT"] = "UTC7";
    TIMEZONES_MIGRATION_MAP["ALMST"] = "UTC7";
    TIMEZONES_MIGRATION_MAP["WAST"] = "UTC7";
    TIMEZONES_MIGRATION_MAP["CXT"] = "UTC7";
    TIMEZONES_MIGRATION_MAP["ALMT"] = "UTC6";
    TIMEZONES_MIGRATION_MAP["MAWT"] = "UTC6";
    TIMEZONES_MIGRATION_MAP["IOT"] = "UTC5";
    TIMEZONES_MIGRATION_MAP["MVT"] = "UTC5";
    TIMEZONES_MIGRATION_MAP["TFT"] = "UTC5";
    TIMEZONES_MIGRATION_MAP["AFT"] = "UTC4";
    TIMEZONES_MIGRATION_MAP["MUT"] = "UTC4";
    TIMEZONES_MIGRATION_MAP["RET"] = "UTC4";
    TIMEZONES_MIGRATION_MAP["SCT"] = "UTC4";
    TIMEZONES_MIGRATION_MAP["IT"] = "UTC3";
    TIMEZONES_MIGRATION_MAP["EAT"] = "UTC3";
    TIMEZONES_MIGRATION_MAP["BT"] = "UTC3";
    TIMEZONES_MIGRATION_MAP["EETDST"] = "UTC3";
    TIMEZONES_MIGRATION_MAP["HMT"] = "UTC3";
    TIMEZONES_MIGRATION_MAP["BDST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["CEST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["CETDST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["EET"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["FWT"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["IST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["MEST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["METDST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["SST"] = "UTC2";
    TIMEZONES_MIGRATION_MAP["BST"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["CET"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["DNT"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["FST"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["MET"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["MEWT"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["MEZ"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["NOR"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["SET"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["SWT"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["WETDST"] = "UTC1";
    TIMEZONES_MIGRATION_MAP["GMT"] = "UTC";
    TIMEZONES_MIGRATION_MAP["UT"] = "UTC";
    TIMEZONES_MIGRATION_MAP["UTC"] = "UTC";
    TIMEZONES_MIGRATION_MAP["Z"] = "UTC";
    TIMEZONES_MIGRATION_MAP["ZULU"] = "UTC";
    TIMEZONES_MIGRATION_MAP["WET"] = "UTC";
    TIMEZONES_MIGRATION_MAP["WAT"] = "UTCM1";
    TIMEZONES_MIGRATION_MAP["NDT"] = "UTCM2";
    TIMEZONES_MIGRATION_MAP["ADT"] = "UTCM3";
    TIMEZONES_MIGRATION_MAP["AWT"] = "UTC";
    TIMEZONES_MIGRATION_MAP["NFT"] = "UTCM3";
    TIMEZONES_MIGRATION_MAP["NST"] = "UTCM3";
    TIMEZONES_MIGRATION_MAP["AST"] = "UTCM4";
    TIMEZONES_MIGRATION_MAP["ACST"] = "UTCM4";
    TIMEZONES_MIGRATION_MAP["ACT"] = "UTCM5";
    TIMEZONES_MIGRATION_MAP["EDT"] = "UTCM4";
    TIMEZONES_MIGRATION_MAP["CDT"] = "UTCM5";
    TIMEZONES_MIGRATION_MAP["EST"] = "UTCM5";
    TIMEZONES_MIGRATION_MAP["CST"] = "UTCM6";
    TIMEZONES_MIGRATION_MAP["MDT"] = "UTCM6";
    TIMEZONES_MIGRATION_MAP["MST"] = "UTCM7";
    TIMEZONES_MIGRATION_MAP["PDT"] = "UTCM7";
    TIMEZONES_MIGRATION_MAP["AKDT"] = "UTCM8";
    TIMEZONES_MIGRATION_MAP["PST"] = "UTCM8";
    TIMEZONES_MIGRATION_MAP["YDT"] = "UTCM8";
    TIMEZONES_MIGRATION_MAP["AKST"] = "UTCM9";
    TIMEZONES_MIGRATION_MAP["HDT"] = "UTCM9";
    TIMEZONES_MIGRATION_MAP["YST"] = "UTCM9";
    TIMEZONES_MIGRATION_MAP["AHST"] = "UTCM10";
    TIMEZONES_MIGRATION_MAP["HST"] = "UTCM10";
    TIMEZONES_MIGRATION_MAP["CAT"] = "UTCM10";
    TIMEZONES_MIGRATION_MAP["NT"] = "UTCM11";
    TIMEZONES_MIGRATION_MAP["IDLW"] = "UTCM12";
})(TIMEZONES_MIGRATION_MAP || (exports.TIMEZONES_MIGRATION_MAP = TIMEZONES_MIGRATION_MAP = {}));
exports.ALL_TIMEZONES = [
    {
        value: "Dateline Standard Time",
        abbr: "DST",
        offset: -12,
        isdst: false,
        text: "(UTC-12:00) International Date Line West",
        utc: ["Etc/GMT+12"],
    },
    {
        value: "UTC-11",
        abbr: "UTCM11",
        offset: -11,
        isdst: false,
        text: "(UTC-11:00) Coordinated Universal Time-11",
        utc: ["Etc/GMT+11", "Pacific/Midway", "Pacific/Niue", "Pacific/Pago_Pago"],
    },
    {
        value: "Hawaiian Standard Time",
        abbr: "HST",
        offset: -10,
        isdst: false,
        text: "(UTC-10:00) Hawaii",
        utc: [
            "Etc/GMT+10",
            "Pacific/Honolulu",
            "Pacific/Johnston",
            "Pacific/Rarotonga",
            "Pacific/Tahiti",
        ],
    },
    {
        value: "Aleutian Islands",
        abbr: "HDT",
        offset: -10,
        isdst: true,
        text: "(UTC-10:00) Aleutian Islands",
        utc: ["US/Aleutian"],
    },
    {
        value: "UTC-10",
        abbr: "UTCM10",
        offset: -10,
        isdst: false,
        text: "(UTC-10:00) Coordinated Universal Time-10",
        utc: ["Etc/GMT+10"],
    },
    {
        value: "Marquesas islands",
        abbr: "MART",
        offset: -9.5,
        isdst: false,
        text: "(UTC-09:30) Marquesas islands",
        utc: ["Pacific/Marquesas"],
    },
    {
        value: "Alaska",
        abbr: "AKDT",
        offset: -9,
        isdst: true,
        text: "(UTC-09:00) Alaska",
        utc: ["US/Alaska"],
    },
    {
        value: "UTC-9",
        abbr: "UTCM9",
        offset: -9,
        isdst: false,
        text: "(UTC-09:00) Coordinated Universal Time-09",
        utc: ["Etc/GMT+9"],
    },
    {
        value: "Pacific Time (US & Canada)",
        abbr: "PT",
        offset: -8,
        isdst: false,
        text: "(UTC-08:00) Pacific Time (US & Canada)",
        utc: ["Canada/Pacific", "US/Pacific"],
    },
    {
        value: "UTC-8",
        abbr: "UTCM8",
        offset: -8,
        isdst: false,
        text: "(UTC-08:00) Coordinated Universal Time-08",
        utc: ["Etc/GMT+8"],
    },
    {
        value: "Mountain Time (US & Canada)",
        abbr: "MT",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) Mountain Time (US & Canada)",
        utc: ["Canada/Mountain", "US/Mountain"],
    },
    {
        value: "Arizona",
        abbr: "AZ",
        offset: -7,
        isdst: false,
        utc: ["US/Arizona"],
        text: "(UTC-07:00) Arizona",
    },
    {
        value: "Rocky Mountains",
        abbr: "CO",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) Rocky Mountains",
        utc: ["US/Mountain"],
    },
    {
        value: "Yukon",
        abbr: "YT",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) Yukon",
        utc: ["Canada/Yukon"],
    },
    {
        value: "La Paz Mazatlan",
        abbr: "SI",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) La Paz Mazatlan",
        utc: ["Mexico/BajaSur", "Mexico/General"],
    },
    {
        value: "UTC-7",
        abbr: "UTCM7",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) Coordinated Universal Time-07",
        utc: ["Etc/GMT+7"],
    },
    {
        value: "Central Time (US & Canada)",
        abbr: "CT",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Central Time (US & Canada)",
        utc: ["Canada/Central", "US/Central"],
    },
    {
        value: "Saskatchewan",
        abbr: "SK",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Saskatchewan",
        utc: ["Canada/Saskatchewan"],
    },
    {
        value: "Easter Island",
        abbr: "EI",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Easter Island",
        utc: ["Chile/EasterIsland"],
    },
    {
        value: "UTC-6",
        abbr: "UTCM6",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Coordinated Universal Time-06",
        utc: ["Etc/GMT+6"],
    },
    {
        value: "Eastern Time (US & Canada)",
        abbr: "ET",
        offset: -5,
        isdst: true,
        text: "(UTC-05:00) Eastern Time (US & Canada)",
        utc: ["Canada/Eastern", "US/Eastern"],
    },
    {
        value: "UTC-5",
        abbr: "UTCM5",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Coordinated Universal Time-05",
        utc: ["Etc/GMT+5"],
    },
    {
        value: "UTC-4",
        abbr: "UTCM4",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Coordinated Universal Time-04",
        utc: ["Etc/GMT+4"],
    },
    {
        value: "Atlantic Time (Canada)",
        abbr: "AT",
        offset: -4,
        isdst: true,
        text: "(UTC-04:00) Atlantic Time (Canada)",
        utc: ["Canada/Atlantic"],
    },
    {
        value: "Newfoundland",
        abbr: "NL",
        offset: -3.5,
        isdst: true,
        text: "(UTC-03:30) Newfoundland",
        utc: ["Canada/Newfoundland"],
    },
    {
        value: "UTC-3",
        abbr: "UTCM3",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Coordinated Universal Time-03",
        utc: ["Etc/GMT+3"],
    },
    {
        value: "Greenland",
        abbr: "GL",
        offset: -2,
        isdst: true,
        text: "(UTC-02:00) Greenland",
        utc: ["America/Godthab"],
    },
    {
        value: "UTC-2",
        abbr: "UTCM2",
        offset: -2,
        isdst: false,
        text: "(UTC-02:00) Coordinated Universal Time-02",
        utc: ["Etc/GMT+2"],
    },
    {
        value: "Azores",
        abbr: "AZOT",
        offset: -1,
        isdst: false,
        text: "(UTC-01:00) Azores",
        utc: ["Atlantic/Azores"],
    },
    {
        value: "UTC-1",
        abbr: "UTCM1",
        offset: -1,
        isdst: false,
        text: "(UTC-01:00) Coordinated Universal Time-01",
        utc: ["Etc/GMT+1"],
    },
    {
        value: "UTC",
        abbr: "UTC",
        offset: 0,
        isdst: false,
        text: "(UTC) Coordinated Universal Time",
        utc: [
            "Etc/GMT",
            "Etc/GMT+0",
            "Etc/GMT-0",
            "Etc/GMT0",
            "Etc/UTC",
            "Etc/Universal",
            "Etc/Zulu",
            "UTC",
            "UTC",
        ],
    },
    {
        value: "British Time",
        abbr: "BT",
        offset: 0,
        isdst: true,
        text: "(UTC) British Time (Dublin, Edinburgh, Lisbon, London)",
        utc: ["Europe/London"],
    },
    {
        value: "Morocco",
        abbr: "MA",
        offset: 0,
        isdst: true,
        text: "(UTC +01:00) Casablanca",
        utc: ["Africa/Casablanca"],
    },
    {
        value: "West Africa Time",
        abbr: "WAT",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) West Central Africa",
        utc: ["Africa/Lagos"],
    },
    {
        value: "Central European Time",
        abbr: "CET",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Paris",
        utc: [
            "Europe/Berlin",
            "Europe/Amsterdam",
            "Europe/Rome",
            "Europe/Stockholm",
            "Europe/Vienna",
        ],
    },
    {
        value: "UTC+1",
        abbr: "UTCM1",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) Coordinated Universal Time+01",
        utc: ["Etc/GMT-1"],
    },
    {
        value: "Eastern European Time",
        abbr: "EET",
        offset: 2,
        isdst: true,
        text: "(UTC+02:00) Athens, Bucharest",
        utc: ["Europe/Athens", "Europe/Bucharest"],
    },
    {
        value: "UTC+2",
        abbr: "UTCM2",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Coordinated Universal Time+02",
        utc: ["Etc/GMT-2"],
    },
    {
        value: "Moscow Standard Time",
        abbr: "MSK",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
        utc: ["Europe/Moscow"],
    },
    {
        value: "Easten Africa Time",
        abbr: "EAT",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Nairobi",
        utc: ["Africa/Nairobi"],
    },
    {
        value: "UTC+3",
        abbr: "UTC3",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Coordinated Universal Time+03",
        utc: ["Etc/GMT-3"],
    },
    {
        value: "Iran Standard Time",
        abbr: "IRST",
        offset: 3.5,
        isdst: false,
        text: "(UTC+03:30) Tehran",
        utc: ["Asia/Tehran"],
    },
    {
        value: "UTC+4",
        abbr: "UTC4",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Coordinated Universal Time+04",
        utc: ["Etc/GMT-4"],
    },
    {
        value: "Afghanistan Time",
        abbr: "AFT",
        offset: 4.5,
        isdst: false,
        text: "(UTC+04:30) Kabul",
        utc: ["Asia/Kabul"],
    },
    {
        value: "UTC+5",
        abbr: "UTC5",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Coordinated Universal Time+05",
        utc: ["Etc/GMT-5"],
    },
    {
        value: "India Standard Time",
        abbr: "IST",
        offset: 5.5,
        isdst: false,
        text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        utc: ["Asia/Kolkata"],
    },
    {
        value: "Nepal Time",
        abbr: "NPT",
        offset: 5.75,
        isdst: false,
        text: "(UTC+05:45) Kathmandu",
        utc: ["Asia/Kathmandu"],
    },
    {
        value: "UTC+6",
        abbr: "UTC6",
        offset: 6,
        isdst: false,
        text: "(UTC+06:00) Coordinated Universal Time+06",
        utc: ["Etc/GMT-6"],
    },
    {
        value: "Myanmar Time",
        abbr: "MMT",
        offset: 6.5,
        isdst: false,
        text: "(UTC+06:30) Yangon (Rangoon)",
        utc: ["Asia/Yangon"],
    },
    {
        value: "Indochina Time",
        abbr: "ICT",
        offset: 7,
        isdst: false,
        text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        utc: ["Asia/Bangkok"],
    },
    {
        value: "UTC+7",
        abbr: "UTC7",
        offset: 7,
        isdst: false,
        text: "(UTC+07:00) Coordinated Universal Time+07",
        utc: ["Etc/GMT-7"],
    },
    {
        value: "China Standard Time",
        abbr: "CST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        utc: ["Asia/Shanghai"],
    },
    {
        value: "UTC+8",
        abbr: "UTC8",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Coordinated Universal Time+08",
        utc: ["Etc/GMT-8"],
    },
    {
        value: "Eucla",
        abbr: "EUCLA",
        offset: 8.75,
        isdst: false,
        text: "(UTC+08:45) Eucla",
        utc: ["Australia/Eucla"],
    },
    {
        value: "UTC+9",
        abbr: "UTC9",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Coordinated Universal Time+09",
        utc: ["Etc/GMT-9"],
    },
    {
        value: "Adelaide",
        abbr: "ADLD",
        offset: 9.5,
        isdst: true,
        text: "(UTC+09:30) Adelaide",
        utc: ["Australia/Adelaide"],
    },
    {
        value: "Darwin",
        abbr: "DRWN",
        offset: 9.5,
        isdst: false,
        text: "(UTC+09:30) Darwin",
        utc: ["Australia/Darwin"],
    },
    {
        value: "Brisbane",
        abbr: "BRSB",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Brisbane",
        utc: ["Australia/Brisbane"],
    },
    {
        value: "Melbourne",
        abbr: "MLBRN",
        offset: 10,
        isdst: true,
        text: "(UTC+10:00) Canberra, Melbourne, Sydney",
        utc: ["Australia/Melbourne"],
    },
    {
        value: "UTC+10",
        abbr: "UTC10",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Coordinated Universal Time+10",
        utc: ["Etc/GMT-10"],
    },
    {
        value: "Lord Howe Island",
        abbr: "LHT",
        offset: 10.5,
        isdst: false,
        text: "(UTC+10:30) Lord Howe Island",
        utc: ["Australia/Lord_Howe"],
    },
    {
        value: "Norfolk Island",
        abbr: "NFT",
        offset: 11,
        isdst: false,
        text: "(UTC+11:00) Norfolk Island",
        utc: ["Pacific/Norfolk"],
    },
    {
        value: "UTC+11",
        abbr: "UTC11",
        offset: 11,
        isdst: false,
        text: "(UTC+11:00) Coordinated Universal Time+11",
        utc: ["Etc/GMT-11"],
    },
    {
        value: "New Zealand Time",
        abbr: "NZT",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Auckland, Wellington",
        utc: ["Pacific/Auckland", "Antarctica/McMurdo"],
    },
    {
        value: "UTC+12",
        abbr: "UTC12",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Coordinated Universal Time+12",
        utc: ["Etc/GMT-12"],
    },
    {
        value: "Chatham Islands",
        abbr: "CHAT",
        offset: 12.75,
        isdst: true,
        text: "(UTC+12:45) Chatham Islands",
        utc: ["Pacific/Chatham"],
    },
    {
        value: "Tonga",
        abbr: "TOT",
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Nuku'alofa",
        utc: ["Pacific/Tongatapu"],
    },
    {
        value: "UTC+13",
        abbr: "UTC13",
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Coordinated Universal Time+13",
        utc: ["Etc/GMT-13"],
    },
    {
        value: "UTC+14",
        abbr: "UTC14",
        offset: 14,
        isdst: false,
        text: "(UTC+14:00) Kiritimati Island",
        utc: ["Pacific/Kiritimati"],
    },
];
/**
 * @deprecated delete it in 2 months
 */
var TIMEZONE_LABEL;
(function (TIMEZONE_LABEL) {
    TIMEZONE_LABEL["NZDT"] = "+13:00\tNew Zealand Daylight Time";
    TIMEZONE_LABEL["IDLE"] = "+12:00\tInternational Date Line, East";
    TIMEZONE_LABEL["NZST"] = "+12:00\tNew Zealand Standard Time";
    TIMEZONE_LABEL["NZT"] = "+12:00\tNew Zealand Time";
    TIMEZONE_LABEL["AESST"] = "+11:00\tAustralia Eastern Summer Standard Time";
    TIMEZONE_LABEL["ACSST"] = "+10:30\tCentral Australia Summer Standard Time";
    TIMEZONE_LABEL["CADT"] = "+10:30\tCentral Australia Daylight Savings Time";
    TIMEZONE_LABEL["SADT"] = "+10:30\tSouth Australian Daylight Time";
    TIMEZONE_LABEL["AEST"] = "+10:00\tAustralia Eastern Standard Time";
    TIMEZONE_LABEL["EAST"] = "+10:00\tEast Australian Standard Time";
    TIMEZONE_LABEL["GST"] = "+10:00\tGuam Standard Time, USSR Zone 9";
    TIMEZONE_LABEL["LIGT"] = "+10:00\tMelbourne, Australia";
    TIMEZONE_LABEL["SAST"] = "+09:30\tSouth Australia Standard Time";
    TIMEZONE_LABEL["CAST"] = "+09:30\tCentral Australia Standard Time";
    TIMEZONE_LABEL["AWSST"] = "+09:00\tAustralia Western Summer Standard Time";
    TIMEZONE_LABEL["JST"] = "+09:00\tJapan Standard Time,USSR Zone 8";
    TIMEZONE_LABEL["KST"] = "+09:00\tKorea Standard Time";
    TIMEZONE_LABEL["MHT"] = "+09:00\tKwajalein Time";
    TIMEZONE_LABEL["WDT"] = "+09:00\tWest Australian Daylight Time";
    TIMEZONE_LABEL["MT"] = "+08:30\tMoluccas Time";
    TIMEZONE_LABEL["AWST"] = "+08:00\tAustralia Western Standard Time";
    TIMEZONE_LABEL["CCT"] = "+08:00\tChina Coastal Time";
    TIMEZONE_LABEL["WADT"] = "+08:00\tWest Australian Daylight Time";
    TIMEZONE_LABEL["WST"] = "+08:00\tWest Australian Standard Time";
    TIMEZONE_LABEL["JT"] = "+07:30\tJava Time";
    TIMEZONE_LABEL["ALMST"] = "+07:00\tAlmaty Summer Time";
    TIMEZONE_LABEL["WAST"] = "+07:00\tWest Australian Standard Time";
    TIMEZONE_LABEL["CXT"] = "+07:00\tChristmas (Island) Time";
    TIMEZONE_LABEL["ALMT"] = "+06:00\tAlmaty Time";
    TIMEZONE_LABEL["MAWT"] = "+06:00\tMawson (Antarctica) Time";
    TIMEZONE_LABEL["IOT"] = "+05:00\tIndian Chagos Time";
    TIMEZONE_LABEL["MVT"] = "+05:00\tMaldives Island Time";
    TIMEZONE_LABEL["TFT"] = "+05:00\tKerguelen Time";
    TIMEZONE_LABEL["AFT"] = "+04:30\tAfganistan Time";
    TIMEZONE_LABEL["MUT"] = "+04:00\tMauritius Island Time";
    TIMEZONE_LABEL["RET"] = "+04:00\tReunion Island Time";
    TIMEZONE_LABEL["SCT"] = "+04:00\tMahe Island Time";
    TIMEZONE_LABEL["IT"] = "+03:30\tIran Time";
    TIMEZONE_LABEL["EAT"] = "+03:00\tAntananarivo, Comoro Time";
    TIMEZONE_LABEL["BT"] = "+03:00\tBaghdad Time";
    TIMEZONE_LABEL["EETDST"] = "+03:00\tEastern Europe Daylight Savings Time";
    TIMEZONE_LABEL["HMT"] = "+03:00\tHellas Mediterranean Time (?)";
    TIMEZONE_LABEL["BDST"] = "+02:00\tBritish Double Standard Time";
    TIMEZONE_LABEL["CEST"] = "+02:00\tCentral European Savings Time";
    TIMEZONE_LABEL["CETDST"] = "+02:00\tCentral European Daylight Savings Time";
    TIMEZONE_LABEL["EET"] = "+02:00\tEastern Europe, USSR Zone 1";
    TIMEZONE_LABEL["FWT"] = "+02:00\tFrench Winter Time";
    TIMEZONE_LABEL["IST"] = "+02:00\tIsrael Standard Time";
    TIMEZONE_LABEL["MEST"] = "+02:00\tMiddle Europe Summer Time";
    TIMEZONE_LABEL["METDST"] = "+02:00\tMiddle Europe Daylight Time";
    TIMEZONE_LABEL["SST"] = "+02:00\tSwedish Summer Time";
    TIMEZONE_LABEL["BST"] = "+01:00\tBritish Summer Time";
    TIMEZONE_LABEL["CET"] = "+01:00\tCentral European Time";
    TIMEZONE_LABEL["DNT"] = "+01:00\tDansk Normal Tid";
    TIMEZONE_LABEL["FST"] = "+01:00\tFrench Summer Time";
    TIMEZONE_LABEL["MET"] = "+01:00\tMiddle Europe Time";
    TIMEZONE_LABEL["MEWT"] = "+01:00\tMiddle Europe Winter Time";
    TIMEZONE_LABEL["MEZ"] = "+01:00\tMiddle Europe Zone";
    TIMEZONE_LABEL["NOR"] = "+01:00\tNorway Standard Time";
    TIMEZONE_LABEL["SET"] = "+01:00\tSeychelles Time";
    TIMEZONE_LABEL["SWT"] = "+01:00\tSwedish Winter Time";
    TIMEZONE_LABEL["WETDST"] = "+01:00\tWestern Europe Daylight Savings Time";
    TIMEZONE_LABEL["GMT"] = "+00:00\tGreenwich Mean Time";
    TIMEZONE_LABEL["UT"] = "+00:00\tUniversal Time";
    TIMEZONE_LABEL["UTC"] = "+00:00\tUniversal Time, Coordinated";
    TIMEZONE_LABEL["Z"] = "+00:00\tSame as UTC";
    TIMEZONE_LABEL["ZULU"] = "+00:00\tSame as UTC";
    TIMEZONE_LABEL["WET"] = "+00:00\tWestern Europe";
    TIMEZONE_LABEL["WAT"] = "-01:00\tWest Africa Time";
    TIMEZONE_LABEL["NDT"] = "-02:30\tNewfoundland Daylight Time";
    TIMEZONE_LABEL["ADT"] = "-03:00\tAtlantic Daylight Time";
    TIMEZONE_LABEL["-03"] = "-03:00\tArgentina";
    TIMEZONE_LABEL["NFT"] = "-03:30\tNewfoundland Standard Time";
    TIMEZONE_LABEL["NST"] = "-03:30\tNewfoundland Standard Time";
    TIMEZONE_LABEL["AST"] = "-04:00\tAtlantic Standard Time (Canada)";
    TIMEZONE_LABEL["ACST"] = "-04:00\tAtlantic/Porto Acre Summer Time";
    TIMEZONE_LABEL["ACT"] = "-05:00\tAtlantic/Porto Acre Standard Time";
    TIMEZONE_LABEL["EDT"] = "-04:00\tEastern Daylight Time";
    TIMEZONE_LABEL["CDT"] = "-05:00\tCentral Daylight Time";
    TIMEZONE_LABEL["EST"] = "-05:00\tEastern Standard Time";
    TIMEZONE_LABEL["CST"] = "-06:00\tCentral Standard Time";
    TIMEZONE_LABEL["MDT"] = "-06:00\tMountain Daylight Time";
    TIMEZONE_LABEL["MST"] = "-07:00\tMountain Standard Time";
    TIMEZONE_LABEL["PDT"] = "-07:00\tPacific Daylight Time";
    TIMEZONE_LABEL["AKDT"] = "-08:00\tAlaska Daylight Time";
    TIMEZONE_LABEL["PST"] = "-08:00\tPacific Standard Time";
    TIMEZONE_LABEL["YDT"] = "-08:00\tYukon Daylight Time";
    TIMEZONE_LABEL["AKST"] = "-09:00\tAlaska Standard Time";
    TIMEZONE_LABEL["HDT"] = "-09:00\tHawaii/Alaska Daylight Time";
    TIMEZONE_LABEL["YST"] = "-09:00\tYukon Standard Time";
    TIMEZONE_LABEL["AHST"] = "-10:00\tAlaska-Hawaii Standard Time";
    TIMEZONE_LABEL["HST"] = "-10:00\tHawaii Standard Time";
    TIMEZONE_LABEL["CAT"] = "-10:00\tCentral Alaska Time";
    TIMEZONE_LABEL["NT"] = "-11:00\tNome Time";
    TIMEZONE_LABEL["IDLW"] = "-12:00\tInternational Date Line, West";
})(TIMEZONE_LABEL || (exports.TIMEZONE_LABEL = TIMEZONE_LABEL = {}));
